var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showMaintenance)?_c('Maintenance'):_c('router-view',{key:_vm.version})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }